import React, { FC } from 'react';
import { IcSuccess72 } from "$assets";
import { Placeholder } from "$uikit";
import { useTranslator } from "$hooks";

export const SuggestionPlaceholder:FC = () => {
  const t = useTranslator();
  return (
    <Placeholder
      icon={<IcSuccess72 />}
      title={t('feed_suggestions_title')}
    >
      {t('feed_suggestions_caption')}
    </Placeholder>
  )
}
